module.exports = __webpack_public_path__ + "static/media/nadinala.367e5294.ogg";